<template>
  <div class="p-8 space-y-4">
    <h2 class="text-2xl">Loan</h2>
    <div class>
      <div class="flex w-full">
        <div class="relative mt-4 mr-4">
          <label class="block">
            <span class="text-gray-700">From</span>
            <input
              v-model="selectedDriverFrom"
              @keyup="searchDriverFrom"
              class="form-input mt-1 w-full block"
              placeholder="Search drivers..."
            />
          </label>
          <transition
            enter-active-class="transition ease-out duration-100"
            enter-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
          >
            <div
              v-if="fromSearchResult.length"
              class="absolute mt-1 inset-x-0 z-50"
            >
              <div
                class="max-h-64 py-2 bg-white shadow rounded-md overflow-y-auto"
              >
                <ul>
                  <li
                    v-for="(result, index) in fromSearchResult"
                    :key="result._id"
                    @click="selectDriverFrom(index)"
                    class="flex items-center space-x-2 px-4 py-2 hover:bg-gray-200 cursor-pointer border-t"
                  >
                    <img
                      class="h-12 w-12 rounded-full object-cover"
                      :src="result.profileImage"
                      :alt="`${result.firstName} ${result.lastName}`"
                    />
                    <div>
                      <p>{{ `${result.firstName} ${result.lastName}` }}</p>
                      <p class="text-gray-600 text-sm font-semibold">
                        {{ result.phoneNumber }}
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </transition>
        </div>

        <div class="relative mt-4 mr-4">
          <label class="block">
            <span class="text-gray-700">To</span>
            <input
              v-model="selectedDriverTo"
              @keyup="searchDriverTo"
              class="form-input mt-1 w-full block"
              placeholder="Search drivers..."
            />
          </label>
          <transition
            enter-active-class="transition ease-out duration-100"
            enter-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
          >
            <div
              v-if="toSearchResult.length"
              class="absolute mt-1 inset-x-0 z-50"
            >
              <div
                class="max-h-64 py-2 bg-white shadow rounded-md overflow-y-auto"
              >
                <ul>
                  <li
                    v-for="(result, index) in toSearchResult"
                    :key="result._id"
                    @click="selectDriverTo(index)"
                    class="flex items-center space-x-2 px-4 py-2 hover:bg-gray-200 cursor-pointer border-t"
                  >
                    <img
                      class="h-12 w-12 rounded-full object-cover"
                      :src="result.profileImage"
                      :alt="`${result.firstName} ${result.lastName}`"
                    />
                    <div>
                      <p>{{ `${result.firstName} ${result.lastName}` }}</p>
                      <p class="text-gray-600 text-sm font-semibold">
                        {{ result.phoneNumber }}
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </transition>
        </div>

        <div class="relative mt-4">
          <div class="pr-3">
            <label class="block">
              <span class="text-gray-700">Status</span>
              <select
                class="form-select w-full"
                v-model="paid"
                @change="getAllLoans"
              >
                <option :selected="paid === null" :value="null">All</option>
                <option :selected="paid === true" :value="true">Paid</option>
                <option :selected="paid === false" :value="false"
                  >Unpaid</option
                >
              </select>
            </label>
          </div>
        </div>

        <div class="relative mt-4">
          <div class="pr-3">
            <label class="block">
              <span class="text-gray-700">Start date</span>
              <v-date-picker :value="startDate" v-model="startDate" />
            </label>
          </div>
        </div>

        <div class="relative mt-4">
          <div class="pr-3">
            <label class="block">
              <span class="text-gray-700">End date</span>
              <v-date-picker :value="endDate" v-model="endDate" />
            </label>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="flex space-x-4">
        <h3 class="flex items-center space-x-4">
          <span>loans</span>
        </h3>
      </div>

      <div
        class="inline-block min-w-full shadow rounded-lg overflow-hidden mt-4"
      >
        <table class="min-w-full leading-normal">
          <thead>
            <tr>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Loan ID
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                From
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                To
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Amount
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Paid
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Paid amount
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Last Transaction Date
              </th>
            </tr>
          </thead>
          <tbody v-if="loans.length" class="relative">
            <tr v-for="wallet in loans" :key="wallet._id">
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="whitespace-no-wrap">{{ wallet._id }}</p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="whitespace-no-wrap">
                  {{
                    wallet.from
                      ? wallet.from.firstName + " " + wallet.from.lastName
                      : "-"
                  }}
                </p>
                <p class="whitespace-no-wrap text-gray-600">
                  {{ wallet.from ? wallet.from._id : "-" }}
                </p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="whitespace-no-wrap">
                  {{
                    wallet.to
                      ? wallet.to.firstName + " " + wallet.to.lastName
                      : "-"
                  }}
                </p>
                <p class="whitespace-no-wrap text-gray-600">
                  {{ wallet.to ? wallet.to._id : "-" }}
                </p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">
                  {{ wallet.amount.toFixed(2) }}
                </p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                {{ wallet.paid }}
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                {{ wallet.paidAmount.toFixed(2) }}
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                {{ wallet.updatedAt }}
              </td>
            </tr>
            <div
              v-if="loading"
              class="absolute inset-0 h-full w-full flex items-center justify-center bg-black bg-opacity-25"
            >
              <i class="material-icons text-6xl spin">sync</i>
              <span class="block invisible">Loading...</span>
            </div>
          </tbody>
          <tbody v-else>
            <tr>
              <td
                colspan="7"
                class="bg-white py-4 text-center text-gray-600 font-semibold"
              >
                <div v-if="loading" class="inline-block">
                  <i class="material-icons text-6xl spin">sync</i>
                  <span class="block invisible">Loading...</span>
                </div>
                <div v-else class="inline-block">
                  <i class="material-icons text-6xl">warning</i>
                  <span class="block">No loans!</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="flex justify-between items-end">
        <p class="text-gray-600">
          Showing
          <strong>{{ start }}</strong> to <strong>{{ end }}</strong> of
          <strong>{{ paginator.count }}</strong> entries
        </p>
        <div class="flex items-center space-x-4">
          <div>
            Per page:
            <select
              class="form-select"
              name="perPage"
              id="perPage"
              @change="setPerPage"
            >
              <option :selected="perPage === '10'" value="10">10</option>
              <option :selected="perPage === '25'" value="25">25</option>
              <option :selected="perPage === '50'" value="50">50</option>
              <option :selected="perPage === '100'" value="100">100</option>
            </select>
          </div>
          <div class="space-x-2 flex">
            <button
              @click="goToPrev"
              type="button"
              class="flex items-center p-2 text-gray-500 hover:text-gray-800 outline-none focus:outline-none"
            >
              <i class="material-icons">chevron_left</i>
            </button>
            <button
              v-for="page in total"
              :key="`pageLink-${page}`"
              type="button"
              class="p-2"
              :class="{
                'text-gray-500 hover:text-gray-800': currentPage !== page,
                'text-gray-900': currentPage === page
              }"
              :disabled="currentPage === page"
              @click="goToPage(page)"
            >
              {{ page }}
            </button>
            <button
              @click="goToNext"
              type="button"
              class="flex items-center p-2 text-gray-500 hover:text-gray-800 outline-none focus:outline-none"
            >
              <i class="material-icons">chevron_right</i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/mixins/Pagination";

export default {
  mixins: [Pagination],
  data() {
    return {
      loading: false,
      paid: null,
      loans: [],
      selectedDriverFrom: "",
      selectedDriverTo: "",
      drivers: [],
      fromSearchResult: [],
      toSearchResult: [],
      fromId: null,
      toId: null,
      startDate: null,
      endDate: null
    };
  },
  watch: {
    startDate() {
      this.getAllLoans();
    },
    endDate() {
      this.getAllLoans();
    },
    currentPage() {
      this.getAllLoans();
    },
    perPage() {
      this.getAllLoans();
    }
  },
  created() {
    var sd = new Date();
    sd.setDate(0);
    sd.setDate(1);
    var ed = new Date();
    ed.setMonth(ed.getMonth() + 1);
    ed.setDate(0);
    this.startDate = sd;
    this.endDate = ed;
    this.getAllLoans();
    this.$http
      .get("/drivers")
      .then(response => {
        this.drivers = response.data.data;
        let driver = this.drivers.find(driver => driver._id == this.driverId);
        if (driver) {
          this.selectedDriverFrom = `${driver.firstName} ${driver.lastName} - ${driver.phoneNumber}`;
        }
      })
      .catch(err => console.log(err));
  },
  methods: {
    getAllLoans() {
      this.loading = true;
      var path = `/loan-histories?populate=["from","to"]&page=${this.currentPage}&limit=${this.perPage}`;
      if (this.fromId) {
        path += "&from=" + this.fromId;
      }
      if (this.toId) {
        path += "&to=" + this.toId;
      }
      if (this.paid && this.paid != "all") {
        path += "&paid=" + this.paid;
      }
      if (this.startDate) {
        path += "&start=" + this.startDate;
      }
      if (this.endDate) {
        path += "&end=" + this.endDate;
      }
      this.$http
        .get(path)
        .then(response => {
          this.loans = response.data.data;
          this.paginator = {
            nextPage: response.data.nextPage,
            prevPage: response.data.prevPage,
            count: response.data.count
          };
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false));
    },
    searchDriverFrom(e) {
      if (e.target.value.trim() === "") {
        this.fromSearchResult = [];
        this.fromId = null;
        this.getAllLoans();
      } else if (!isNaN(parseInt(e.target.value))) {
        this.fromSearchResult = this.drivers.filter(driver => {
          return driver.phoneNumber.slice(-4).includes(e.target.value);
        });
      } else {
        this.fromSearchResult = this.drivers.filter(driver => {
          let name = driver.firstName + " " + driver.lastName;
          return name.toLowerCase().includes(e.target.value.toLowerCase());
        });
      }
    },
    searchDriverTo(e) {
      if (e.target.value.trim() === "") {
        this.toSearchResult = [];
        this.toId = null;
        this.getAllLoans();
      } else if (!isNaN(parseInt(e.target.value))) {
        this.toSearchResult = this.drivers.filter(driver => {
          return driver.phoneNumber.slice(-4).includes(e.target.value);
        });
      } else {
        this.toSearchResult = this.drivers.filter(driver => {
          let name = driver.firstName + " " + driver.lastName;
          return name.toLowerCase().includes(e.target.value.toLowerCase());
        });
      }
    },
    selectDriverFrom(index) {
      let driver = this.fromSearchResult[index];
      this.selectedDriverFrom = `${driver.firstName} ${driver.lastName} - ${driver.phoneNumber}`;
      this.fromId = driver._id;
      this.fromSearchResult = [];
      this.getAllLoans();
    },
    selectDriverTo(index) {
      let driver = this.toSearchResult[index];
      this.selectedDriverTo = `${driver.firstName} ${driver.lastName} - ${driver.phoneNumber}`;
      this.toId = driver._id;
      this.toSearchResult = [];
      this.getAllLoans();
    }
  }
};
</script>
